import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollView, StyleSheet } from 'react-native';
import { useCopy } from 'common';
import { theme } from '@xbto/design-system';
import { AdCard } from '../../organisms';
import { SectionTitle } from '../../molecules';
export function SectionOfferings() {
    /**
     * Vars
     */
    const { offerings } = useCopy();
    /**
     * DOM
     */
    return (_jsxs(_Fragment, { children: [_jsx(SectionTitle, { mb: "6", children: "Our offerings" }), _jsx(ScrollView, { horizontal: true, style: $.scroll, contentContainerStyle: $.scrollContent, children: offerings.map(offering => (_jsx(AdCard, Object.assign({}, offering), offering.id))) })] }));
}
const $ = StyleSheet.create({
    scroll: {
        borderRadius: theme.radius.md,
    },
    scrollContent: {
        borderRadius: theme.radius.md,
        gap: theme.spacing['2'],
    },
});
